import { z } from 'zod'

import { GROUP_STATUSES } from '@/features/groups/constants'

/**
 * The group screens keep their state in the URL, for the same reason the customer screens do: a
 * filtered list is a place. "Which groups at Kaneshie still have no officer?" should be a link
 * somebody can send, and pressing Back out of a group should land on the page of the list it was
 * opened from.
 *
 * Every value is read back through `.catch()`, so a hand-edited or stale URL degrades to the
 * default rather than throwing an operator out of the screen.
 */

export const DEFAULT_PAGE_SIZE = 25

export const groupListSearchSchema = z.object({
  search: z.string().trim().min(1).optional().catch(undefined),
  status: z.enum(GROUP_STATUSES).optional().catch(undefined),
  branchId: z.string().min(1).optional().catch(undefined),
  loanOfficerId: z.string().min(1).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z.number().int().min(10).max(200).optional().catch(undefined),
})

export type GroupListSearch = z.infer<typeof groupListSearchSchema>

export const GROUP_DETAIL_TABS = ['overview', 'members', 'meetings', 'health'] as const

export type GroupDetailTab = (typeof GROUP_DETAIL_TABS)[number]

export const groupDetailSearchSchema = z.object({
  tab: z.enum(GROUP_DETAIL_TABS).optional().catch(undefined),
})
